var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',{staticClass:"el-h"},[_c('top')],1),_c('el-main',[_c('router-view')],1),_c('el-footer',[_c('btm')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }